import React from 'react';
import './activities.scss';
import { useAuth } from  '../../contexts/auth'; 

//import 'devextreme/dist/css/dx.light.css';
import 'devexpress-gantt/dist/dx-gantt.min.css';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  Pager,
  Paging,
  FilterRow,
  Lookup,
  Editing,
  Selection,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel,
  Toolbar,
  Popup,
  Form
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';

import { useState, useEffect, useCallback} from "react";
import { Item } from 'devextreme-react/form';
import { TabPanel} from 'devextreme-react/tab-panel';
import {Button as ToolbarButton} from 'devextreme-react/button';
import { confirm } from 'devextreme/ui/dialog';

import Gantt, {
  Tasks,
  Resources,
  ResourceAssignments,
  Column as GColumn,
  Toolbar as GToolbar,
  Item as GItem
} from 'devextreme-react/gantt';

import {
  //Item,
  RequiredRule
} from 'devextreme-react/form';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Attivita'





export default function Activities() {

  var ganttRef = React.createRef();
  var taskDataGridRef = React.createRef();

  const [commesse, setCommesse] = useState({});
  const [risorse, setRisorse] = useState({});
  const [stati, setStati] = useState({});

  const [tasks, setTasks] = useState({});
  const [resources, setResources] = useState({});
  const [resourceAssignments, setResourceAssignments] = useState({});

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [commessaFilter, setCommessaFilter] = useState();

  //const [parents, setParents] = useState({});

  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);

  const { user } = useAuth(); 

  // if (!user) 
  //   Logout();

  const filterPayload = { 
    commessa: commessaFilter
  };

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/Find',
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
    var newUrl1 =  newServiceUrl1 + "/GetOpen";

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/AttivitaStato';
    var newUrl2 =  newServiceUrl2 + "/GetAction";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
    var newUrl3 =  newServiceUrl3 + "/GetRisorse";

    const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Tasks';
    const id = commessaFilter === null || commessaFilter === undefined? 0: commessaFilter
    var newUrl4 =  newServiceUrl4 + "/GetByProject/" + id;

    const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Resources';
    var newUrl5 =  newServiceUrl5 + "/GetAction";

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_ResourceAssignments';
    var newUrl6 =  newServiceUrl6 + "/GetAction";

    // const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Attivita';
    // var newUrl7 =  newServiceUrl7 + "/FindParents";
  
    const fetchData = async () => {
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response1 = await fetch(newUrl1,requestOptions);
        const json1 = await response1.json();
        //console.log(json1);
        setCommesse(json1);

        const response2 = await fetch(newUrl2);
        const json2 = await response2.json();
        //console.log(json1);
        setStati(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        //console.log(json1);
        setRisorse(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        console.log(json1);
        setTasks(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        console.log(json1);
        setResources(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        console.log(json1);
        setResourceAssignments(json6);

        // const response7 = await fetch(newUrl7);
        // const json7 = await response7.json();
        // console.log(json1);
        // setParents(json7);
  
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, [selectedIndex,commessaFilter]);

  // const onTabSelectionChanged = useCallback((e) => {
  //   //notify("The button was clicked");
  //   ;
  // }, []);

  const allowedPageSizes = [5, 10, 20];

  const selectBoxOptions = {
    width: 200,
    items: commesse,
    valueExpr: 'id',
    displayExpr: 'nomeEsteso',
    placeholder:"<Commessa>",
    showClearButton:true,
    onValueChanged: (args) => {
      setCommessaFilter(args.value);
    },
    value: commessaFilter
  };

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data !== null && data !== undefined) {
      setCurrentRow(data.id);
      setIsRowSelected(true);
    } else{
      setIsRowSelected(false);
    }
      
  }

  const onTabSelectionChanged = useCallback((args) => {
    if (args.name === 'selectedIndex') {
      setSelectedIndex(args.value);
    }
  }, [setSelectedIndex]);

  // function renderTasksGanttTab() {
  //   return <TasksGantt/>;
  // };

  // function renderTasksGridTab() {
  //   return <TasksGrid/>;
  // };

  const addButtonOptions = {
  icon: 'plus',
  hint: 'Nuova Attività'
  // onClick: () => {
  //   notify('Add button has been clicked!');
  // },
};

  function TasksGantt() {

    return (

    
    <Gantt
      ref={ref => ganttRef = ref}
      taskListWidth={500}
      scaleType="weeks"
      height={700}
      rootValue={0}
    >
       <Tasks 
        dataSource={tasks} 
        keyExpr="id"
        parentIdExpr="parentId"
        titleExpr="descrizione"
        progressExpr="completamento"
        startExpr="dataInizio"
        endExpr="dataFine"
       />
      <Resources dataSource={resources} />
      <ResourceAssignments dataSource={resourceAssignments} />
     
       
      <GToolbar>
        <GItem name="undo" />
        <GItem name="redo" />
        <GItem name="separator" />
        <GItem name="zoomIn" />
        <GItem name="zoomOut" />
        <GItem name="separator" />
        <GItem name="showResources" />
      </GToolbar>

      <GColumn
        dataField="descrizione"
        caption="Attività"
        width={300}
      />
      <GColumn
        dataField="strDataInizio"
        caption="Data Inizio"
      />
      <GColumn
        dataField="strDataFine"
        caption="Data Fine"
      />
    </Gantt>
  )
  };

  // function onRowInserting(e) {
  //   if (e.data.parentId !== null)
  //     e.data.parentId = 0;
  // };

  function duplicateActivity(e) {
    let result = confirm("<i>Procedere con la duplicazione dell'attività?</i>", "Duplicazione Attività");
    result.then((dialogResult) => {
      if  (dialogResult) {
        duplica(currentRow);
      }  
    });
  }
    
  const duplica= (idAttivita) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Attivita/Duplicate/' + idAttivita;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        taskDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function onInitNewRow(e) {
    e.data.parentId = 0;
    e.data.completamento = 0;
    e.data.attivitaStatoId = 1;
  }

  function TasksGrid() {

    return (
      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
        onInitNewRow={onInitNewRow}
        onSelectionChanged={onRowSelectionChanged}
        dateSerializationFormat= {'yyyy-MM-dd'}
        ref={ref => taskDataGridRef = ref}
      >

        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
          showInfo={true}
        />
        <Paging defaultPageSize={10} />

         <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Toolbar>
          <Item name="addRowButton"  options={addButtonOptions} location="before"/>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='copy'
              hint='Duplica'
              onClick={duplicateActivity} 
              disabled={!isRowSelected}
            />
          </Item>
          <Item location="after"
            locateInMenu="auto"
            widget="dxSelectBox"
            options={selectBoxOptions} >
          </Item>
          <Item name="searchPanel" className="offer-toolbar"/>
        </Toolbar>
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}   
          >
          <Popup   title= "&nbsp;&nbsp;&nbsp;Attività " showTitle={true} width={800} height={625} />
         
          <Form>
              <Item itemType="group" caption="" colCount={2} colSpan={2}>
              
                <Item dataField="id"  />
                <Item itemType="empty"/>
                <Item dataField="commessaId" colSpan={2} />
                <Item dataField="descrizione" colSpan={2} />
                <Item dataField="risorsaId"/>
                <Item dataField="attivitaStatoId" />
                <Item dataField="dataInizio"/>
                <Item dataField="dataFine" />
                <Item dataField="completamento" /> 
                <Item itemType="empty"/>
             
              </Item> 
            </Form>

            </Editing>
        <Column dataField="id" caption="#" width={60} allowEditing={false}/>
    
        <Column dataField="parentId" caption="#" width={60} visible={false}/>
        
        <Column dataField="commessaId" caption="Commessa"  width={400} allowHeaderFiltering={true} groupIndex={0}>
          <Lookup dataSource={commesse} displayExpr="nomeEsteso" valueExpr="id" />
          <RequiredRule/>
        </Column>
        <Column dataField="codice" visible={false}/>
        <Column dataField="descrizione" width={400} >
          <RequiredRule/>
        </Column>
        <Column dataField="risorsaId" caption="Assegnata a" width={140} >
          <Lookup dataSource={risorse} displayExpr="nome" valueExpr="id" />
          <RequiredRule/>
        </Column>
        <Column dataField="dataInizio" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Inizio" />
        <Column dataField="dataFine" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Fine" />
        <Column dataField="attivitaStatoId" caption="Stato" width={120} >
          <Lookup dataSource={stati} displayExpr="nome" valueExpr="id" />
        </Column>
        <Column dataField="durata" visible={false}/>
        <Column dataField="prioritaId" visible={false} />
        <Column dataField="completamento" caption="Complet. %"/>
    
      </DataGrid>  
    )
  };

return(
<React.Fragment>
    <h2 className={'content-block'}>Attività</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <div>
          
          <TabPanel    
            onOptionChanged={onTabSelectionChanged}
          >
            <Item title="Dati" render={TasksGrid} />
            <Item title="Gantt" render={TasksGantt} />
          </TabPanel>
          
        </div>  
      </div>
    </div>
  </React.Fragment>
)
};
